import script from "./UserSwitch.vue?vue&type=script&setup=true&lang=js"
export * from "./UserSwitch.vue?vue&type=script&setup=true&lang=js"

import "./UserSwitch.vue?vue&type=style&index=0&id=f06c363c&lang=css"

const __exports__ = script;

export default __exports__